<template>
  <v-app>
    <SideBarEduEduMais />
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import SideBarEduEduMais from "../../Bar/SideBarEduEduMais.vue";


export default {
  name: "EduEduMaisContainer",

  components: {
    SideBarEduEduMais,
  },

  mounted() {
      const { restricted } = this.user.data
      if (restricted) this.$router.push({ path: '/fl' });
  },

  computed: {
      ...mapGetters({
      user: "user",
      }),
  }
  
};
</script>
